/**
 * Resolve the display model name for a booking / vehicle document.
 *
 * When a customer picks "Other" from the model dropdown, the actual model
 * name is captured in a free-text field. The customer-facing value MUST
 * always be that free-text — never the placeholder word "Other".
 *
 * Accepts:
 *   • a booking with flat fields  { vehicle_model, vehicle_model_other }
 *   • a booking with a nested sub-doc  { vehicle: { model, model_other } }
 *   • the nested sub-doc itself  { model, model_other }
 */
export function resolveVehicleModel(source) {
  if (!source || typeof source !== "object") return "";
  // Nested sub-doc case: passed { model, model_other } directly
  if (source.model_other && String(source.model_other).trim()) {
    return String(source.model_other).trim();
  }
  // Booking flat field
  if (source.vehicle_model_other && String(source.vehicle_model_other).trim()) {
    return String(source.vehicle_model_other).trim();
  }
  // Booking with nested vehicle sub-doc
  const nested = source.vehicle || {};
  if (nested.model_other && String(nested.model_other).trim()) {
    return String(nested.model_other).trim();
  }
  return source.model || source.vehicle_model || nested.model || "";
}
